export default __webpack_public_path__ + "static/media/map.5a2d8a39.png";